import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass'],
  standalone: true,
})
export class FooterComponent {
  readonly currentlyYear = new Date().getFullYear();

  screenWidth!: any;
  gctiLogo!: string;

  @HostListener('window:resize', ['event'])
  onResize(event?:any) {
    this.screenWidth = window.innerWidth;
    if(this.screenWidth < 992) this.gctiLogo = 'assets/images/logos/gcti.svg'
    else this.gctiLogo = 'assets/images/logos/gcti-expanded.svg'
  }

  ngOnInit(): void {
    this.onResize()
  }
}
